<template>
    <main
        v-if="possuiPermissao('SCHEDULING_V')"
        :style="`width: calc(100% - ${sideBarWidth}px) !important; transform: translateX(${sideBarWidth}px); transition: all 0.6s; margin-top: 1rem`"
	    class="dashboard"
    >
		<div>
			<section class="title-month">
				<button
					class="button-arrow"
					@click="findMonth(-1)"
				>
					<ChevronsLeftIcon class="icons-chevrons" color="var(--cal-header-color)"/>
				</button>
				<TitleMonth
					:options="{
						label: optionsTitleMes.label || null,
						backColor: optionsTitleMes.backColor || null,
						color: optionsTitleMes.color || null,
					}"
					style="width: 90% !important;"
				/>
				<button
					class="button-arrow"
					@click="findMonth(1)"
				>
					<ChevronsRightIcon class="icons-chevrons" color="var(--cal-header-color)"/>
				</button>
			</section>
			<section class="calendar">
				<div
				v-for="diaSem in diasSemana"
				:key="diaSem.ordem"
				>
				<LabelDay
					:options="{
						label: diaSem.label,
						backColor: diaSem.backColor,
						color: diaSem.color,
					}"
				/>
				</div>
				<div v-for="item in servicesScheduled" :key="item.day">
				<ShowDay
					:options="{
						day: item.day,
						value: item.scheduled && item.scheduled.length > 0 ? item.scheduled.filter(ele => ele.status === 'PENDING' || ele.status === 'CONFIRMED') : '',
						show: item.show,
						color: item.color,
						backColor: item.backColor,
						colorTextDay: item.colorTextDay,
						today: item.today,
						scheduling: true,
						sideBarWidth
					}"
					@clickShowDay="modalScheduled(item)"
				/>
				</div>
				<div
					v-if="isLoading"
					style="position: fixed; height: 50vh; width: 100%; display: flex; align-items: center; justify-content: center;">
					<div class="spinner-border" role="status">
						<span class="sr-only">Carregando...</span>
					</div>
				</div>
			</section>
		</div>
		<b-modal
			ref="modalScheduled"
			hide-footer
			hide-header
			size="md"
			no-overflow
			hide-no-focus
			no-close-on-backdrop
			hide-header-close
		>
			<div class="title-modal">
				<div class="title-text-modal">{{ titleModal }}</div>
				<div
					class="float-right btn-hover-modal"
					@click="fecharModal('modalScheduled')"
				>
					<xIcon/>
				</div>
			</div>
			<div class="table-content pb-4 mt-5">
				<div class="menu">
					<PlusCircleIcon v-if="possuiPermissao('SCHEDULING_I') || possuiPermissao('SCHEDULING_U')" class="btn-menu"
						@click="schedulingEdit(null)"
					/>
					<b-dropdown title="" variant="link">
						<template #button-content>
							<FilterIcon class="btn-menu ml-2"/>
						</template>
						<div class="ml-3 mb-1">
							<b-form-checkbox :indeterminate="chekcOptions" :checked="allSelected" @change="toggleAllSelected">
								Todos
							</b-form-checkbox>
						</div>
						<div v-for="(option, index) in optionsFilter" :key="index" class="ml-4 mb-1">
							<b-form-checkbox v-model="filtersSelected" :value="option">
								{{ option }}
							</b-form-checkbox>
						</div>
					</b-dropdown>
				</div>
				<div class="scroll">
					<table border="0">
						<thead>
							<tr class="pt-1 pb-1">
								<th v-bind:style="isMobile ? 'width: 10%' : 'width: 8%'">
									Hora
								</th>
								<th v-bind:style="isMobile ? 'width: 29%' : 'width: 30%'">
									Cliente
								</th>
								<th v-bind:style="isMobile ? 'width: 32%' : 'width: 42%'">
									Serviço
								</th>
								<th>
									Inicio<br>Final
								</th>
								<th style="width: 48px;"/>
								<th style="width: 48px;"/>
							</tr>
						</thead>
					</table>
				</div>
				<div class="scroll">
					<table border="0" class="table">
						<tbody>
							<tr
								class="pt-1 pb-1 border-b center-vh" style="cursor: pointer;"
								v-for="(item, index) in servicesScheduledOfDay" :key="index"
							>
								<td v-bind:style="isMobile ? 'width: 10%' : 'width: 8%'" @click="schedulingEdit(item)">{{ item.scheduleStartTime }}<br>{{ item.scheduleEndTime }}</td>
								<td v-bind:style="isMobile ? 'width: 29%' : 'width: 30%'" @click="schedulingEdit(item)">{{ item.customer }}</td>
								<td v-bind:style="isMobile ? 'width: 32%' : 'width: 42%'" @click="schedulingEdit(item)">{{ item.service }}</td>
								<td v-bind:style="isMobile ? 'width: calc(29% - 70px)' : 'width: calc(20% - 72px)'" @click="schedulingEdit(item)">{{ item.startTime }}<br>{{ item.endTime ? item.endTime : item.startTime ? '>>>' : '' }}</td>
								<td class="center" :title="STATUS[item.status]" :style="getStyle(item.status)">
									<ClockIcon v-if="item.status === 'PENDING'"/>
									<PlayCircleIcon v-else-if="item.status === 'CONFIRMED'"/>
									<RefreshCwIcon v-else-if="item.status === 'RESCHEDULED'"/>
									<XIcon v-else-if="item.status === 'CANCELLED'"/>
									<UserXIcon v-else-if="item.status === 'NO_SHOW'"/>
									<CheckIcon v-else-if="item.status === 'COMPLETED'"/>
								</td>
								<td class="center">
									<b-dropdown v-if="item.status === 'PENDING' || item.status === 'CONFIRMED'" no-caret left variant="link" title="Ações">
										<template #button-content>
											<more-vertical-icon style="color: grey; margin-left: -2px"/>
										</template>
										<b-dropdown-item
											@click="actionService(item, 'start')"
											:disabled="getStatus(item, 'start') || !isToday()"
										>
											Iniciar
										</b-dropdown-item>
										<b-dropdown-item
											@click="actionService(item, 'end')"
											:disabled="getStatus(item, 'end')"
										>
											Finalizar
										</b-dropdown-item>
										<b-dropdown-item
											@click="actionService(item, 'cancel')"
											:disabled="getStatus(item, 'cancel')"
										>
											Cancelar
										</b-dropdown-item>
										<b-dropdown-item
											@click="actionService(item, 'reschedule')"
											:disabled="getStatus(item, 'reschedule')"
										>
											Reagendar
										</b-dropdown-item>
										<b-dropdown-item
											@click="actionService(item, 'missing')"
											:disabled="getStatus(item, 'missing')"
										>
											Faltou
										</b-dropdown-item>

									</b-dropdown>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</b-modal>
		<b-modal
			ref="modalScheduledEdit"
			hide-footer
			hide-header
			size=""
			no-overflow
			hide-no-focus
			no-close-on-backdrop
			hide-header-close
		>
			<div class="title-modal">
				<div class="title-text-modal">{{ titleModalEdit }}</div>
				<div
					class="float-right btn-hover-modal"
					@click="fecharModal('modalScheduledEdit')"
				>
					<xIcon/>
				</div>
			</div>
			<div class="modal-edicao mb-3 modal-edicao-label mt-5">
				<b-row class="mb-1 d-block">
					<b-col>
						<b-button class="p-0 btn-notify" @click="addTaskReminder()">Adicionar notificação</b-button>
					</b-col>
					<div v-if="reminderTask.length"
						class="mt-1 border ml-3 mr-3"
						style="height: 5.20rem !important; overflow-y: scroll; overflow-x: hidden"
					>
						<b-row v-for="i in reminderTask.length" :key="i" class="mt-0 mb-0" style="align-items: center;">
							<div style="width: 100%;" class="ml-4 text-parcela">
								{{ reminderTask[i - 1].description }}
							</div>
							<div
								class="btn-pay btn-pay-del"
								title="Apagar"
								@click="delTaskReminder(i - 1)"
								style="margin-top: 2px; margin-left: -80px"
							>
								<Trash2Icon size="24" alt="Apagar"/>
							</div>
						</b-row>
					</div>
				</b-row>
				<b-row class="mb-3">
					<b-col class="d-block text-parcela">
						<span class="label-conta">Hora</span>
						<vue-timepicker
							name="start-time"
							class="d-flex"
							v-model="startTime"
							format="HH:mm"
							:minute-interval="minuteInterval"
							:hour-range="hourRange"
							v-validate="{ required: true }"
							:state="validateState('start-time')"
							:disabled="disabledHour"
						/>
					</b-col>
					<b-col class="d-block text-parcela">
						<span class="label-conta">Duração</span>
						<vue-timepicker
							name="duration-time"
							class="d-flex"
							v-model="serviceDuration"
							format="HH:mm"
							:minute-interval="minuteInterval"
							:hour-range="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
							v-validate="{ required: true }"
							:state="validateState('duration-time')"
							:disabled="disabledHour"
						/>
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col cols="3" class="d-block text-parcela" style="text-align: center;">
						<span class="label-conta">Eventual</span>
						<ToggleSwitch
							name="eventual"
							class="toggle-tipo-conta mt-1"
							:value="eventual"
							@toggle="_ => changeToggle(eventual, 'eventual')"
						/>
					</b-col>
					<b-col cols="9" v-if="eventual" class="d-block text-parcela">
						<span class="label-conta">Cliente</span>
						<b-form-input
							name="customer-name"
							class="modal-edicao-input"
							type="text"
							v-model="customerName"
							autocomplete="off"
							placeholder="Nome do cliente"
							v-validate="'required|maxLength:50'"
							:state="validateState('customer-name')"
						/>
					</b-col>
					<b-col cols="9" v-else class="d-block text-parcela">
						<span class="label-conta">
							Cliente
						</span>
						<div>
							<b-form-select
								class="modal-edicao-input"
								v-model="selectedCustomer"
								name="schedulingCustomer"
								:options="optionsCustomer"
								:disabled="isLoading"
								v-validate="{ required: true }"
								:state="validateState('schedulingCustomer')"
							>
								<template slot="first">
									<option :value="null">
										Selecione
									</option>
								</template>
							</b-form-select>
						</div>
					</b-col>
					<b-col cols="12" v-if="eventual" class="d-block text-parcela">
						<span class="label-conta">Serviço</span>
						<b-form-input
							name="service-name"
							class="modal-edicao-input"
							type="text"
							v-model="serviceName"
							autocomplete="off"
							placeholder="Detalhe o serviço"
							v-validate="'required|maxLength:100'"
							:state="validateState('service-name')"
						/>
					</b-col>
					<b-col cols="12" v-else class="d-block text-parcela">
						<span class="label-conta">
							Serviço
						</span>
						<div>
							<b-form-select
								class="modal-edicao-input"
								v-model="selectedService"
								name="schedulingService"
								:options="optionsService"
								:disabled="isLoading"
								v-validate="{ required: true }"
								:state="validateState('schedulingService')"
								@input="setValueService()"
							>
								<template slot="first">
									<option :value="null">
										Selecione
									</option>
								</template>
							</b-form-select>
						</div>
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col class="d-block text-parcela">
						<span class="label-conta">Valor</span>
						<b-form-input
							name="service-value"
							class="modal-edicao-input number-class"
							type="text"
							inputmode="numeric"
							v-model="serviceValue"
							autocomplete="off"
							placeholder=""
							v-validate="'required'"
							:state="validateState('service-value')"
							@input="updateValue('serviceValue')"
							@focus="handleFocus('serviceValue')"
							@blur="handleBlur('serviceValue')"
						/>
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col class="d-block text-parcela">
						<span class="label-conta">Observações</span>
						<b-form-input
							name="comments"
							class="modal-edicao-input"
							type="text"
							v-model="comments"
							autocomplete="off"
							placeholder=""
							v-validate="'maxLength:255'"
							:state="validateState('service')"
						/>
					</b-col>
				</b-row>
			</div>
			<b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="fecharModal('modalScheduledEdit')">Cancelar</b-button>
			<b-button class="mt-3 float-left btn-modal btn-limpar" @click="limparModal()">Limpar</b-button>
			<b-button
				class="mt-3 ml-1 float-right btn-modal btn-salvar"
				@click="save"
				:disabled="invalidForm || disabledHour || saving"
			>
				Salvar
			</b-button>
			<b-modal
				ref="modalAddTaskReminder"
				hide-footer
				hide-header
				size="sm"
				no-overflow
				hide-no-focus
			>
				<div class="title-modal">
					<div class="title-text-modal">⏰ Antes de ...</div>
					<div
						class="float-right btn-hover-modal"
						@click="fecharModal('modalAddTaskReminder')"
					>
						<xIcon/>
					</div>
				</div>
				<div
					class="ml-3 mr-3 mt-5"
				>
					<b-row v-for="i in optionsReminderTask.length" :key="i" class="border mt-0 mb-1 d-flex align-items-center">
						<div v-if="!optionsReminderTask[i - 1].checked"
							class="d-flex text-parcela align-items-center ml-2 mb-1 mt-1"
							style="cursor: pointer;"
							@click="selectOptionTaskReminder(i - 1)"
						>
							<input
								style="cursor: pointer;"
								class="mr-2"
								type="checkbox"
								:disabled="true"
							/>
							<span>
								{{ optionsReminderTask[i - 1].description }}
							</span>
						</div>
					</b-row>
				</div>
				<b-modal
					ref="modalReminderTaskCustomer"
					hide-footer
					hide-header
					size="sm"
					no-overflow
					hide-no-focus
				>
					<div class="title-modal">
						<div class="title-text-modal">⏰ Personalizado</div>
						<div
						class="float-right btn-hover-modal"
						@click="fecharModal('modalReminderTaskCustomer')"
					>
						<xIcon/>
					</div>
					</div>
					<div
						class="mt-6 mb-2 w-100"
					>
						<div class="w-100 d-flex justify-center">
							<b-col cols="5"
								class="d-flex text-parcela ml-2 mb-1 mt-1 mr-0"
							>
								<input
									class="w-100 form-control time-pick"
									style="text-align: center;"
									name="taskReminderCustomerValue"
									v-model="taskReminderCustomerValue"
									type="number"
									min="1"
									v-validate="'required|noZeroCurrency'"
									:state="validateState('taskReminderCustomerValue')"
								/>
							</b-col>
							<b-col cols="7">
								<b-form-select
									class="modal-edicao-input"
									v-model="taskReminderCustomerDelay"
									name="taskReminderCustomerDelay"
									:options="optionsCustomerDelay"
									v-validate="{ required: true }"
									:state="validateState('taskReminderCustomerDelay')"
								/>
							</b-col>
						</div>
						<div class="w-100 d-flex justify-center">
							<b-button
								class="mt-4 btn-modal btn-salvar"
								@click="addTaskReminderCustomer"
								:disabled="invalidTaskReminderCustomer"
							>
								Adicionar
							</b-button>
						</div>
					</div>
				</b-modal>

			</b-modal>
		</b-modal>
    </main>
</template>

<script>
	import { mapState } from "vuex";
	import { possuiPermissao } from "../helpers/permissions";
	import { SchedulingService } from "@/services/scheduling";
	import ShowDay from "../components/ShowDay.vue";
	import LabelDay from "../components/LabelDay.vue";
	import TitleMonth from "../components/TitleMonth.vue";
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { numberFormatted, stringToNumber, validateNumber, isNullValue, stringToNumberToFixed, diffTime } from "@/helpers/common";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { CustomerService } from "@/services/customer";
	import { ProductService } from "@/services/product";
	import { ref } from "vue";

	export default {
		components: {
			ShowDay,
			LabelDay,
			TitleMonth,
			ToggleSwitch
		},

		data () {
			return {
				ptBR,
				schedulingService: new SchedulingService(),
				customerService: new CustomerService(),
				productService: new ProductService(),

				possuiPermissao,
				services: {},
				selectedIdScheduling: null,
				isLoading: false,
				dateSearch: new Date(),
				servicesScheduled: [],
				optionsTitleMes: {},
				diasSemana: [],
				titleModal: "",
				titleModalEdit: "",
				AllServicesScheduledOfDay: [],
				servicesScheduledOfDay: [],
				serviceName: "",
				serviceValue: "0,00",
				customerName: "",
				comments: "",
				startTime: this.getNowHour(),
				serviceDuration: "01:00",
				eventual: false,
				idCustomer: null,
				idService: null,
				selectedCustomer: null,
				optionsCustomer: [],
				selectedService: null,
				optionsService: [],
				dataScheduled: new Date(),

				isMobile: false,
				STATUS: {
					PENDING: "Aguardando",
					CONFIRMED: "Em andamento",
					CANCELLED: "Cancelado",
					COMPLETED: "Executado",
					RESCHEDULED: "Reagendado",
					NO_SHOW: "Faltou"
				},

				hourRange: [],
				minuteInterval: "15",
				disabledHour: false,
				optionsFilter: [
					"Aguardando",
					"Em andamento",
					"Cancelado",
					"Executado",
					"Reagendado",
					"Faltou"
				],
				filtersSelected: [],
				saving: false,
				intervalId: null,
				reminderTask: [],
				optionsReminderTask: [
					{ description: "10 Minutos antes", valueMinutes: 10, checked: false },
					{ description: "30 Minutos antes", valueMinutes: 30, checked: false },
					{ description: "1 Hora antes", valueMinutes: 60, checked: false },
					{ description: "1 Dia antes", valueMinutes: (24 * 60), checked: false },
					{ description: "1 Semana antes", valueMinutes: (7 * 24 * 60), checked: false },
					{ description: "Personalizado", valueMinutes: null, checked: false }
				],
				taskReminderCustomerValue: "10",
				taskReminderCustomerDelay: "1",
				invalidTaskReminderCustomer: true,
				optionsCustomerDelay: [
					{
						value: 1,
						text: "Minutos"
					}, {
						value: 60,
						text: "Horas"
					}, {
						value: (24 * 60),
						text: "Dias"
					}, {
						value: (7 * 24 * 60),
						text: "Semanas"
					}, {
						value: (30 * 24 * 60),
						text: "Meses"
					}
				]
			};
		},

		watch: {
			filtersSelected: "reFindServicesDay"
		},

		computed: {
			...mapState(["sideBarWidth"]),
			allSelected () {
				return this.filtersSelected.length === this.optionsFilter.length;
			},
			chekcOptions () {
				return this.filtersSelected.length > 0 && this.filtersSelected.length < this.optionsFilter.length;
			}
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
			clearInterval(this.intervalId);
		},

		async mounted () {
			this.filtersSelected = [
				"Aguardando",
				"Em andamento",
				"Cancelado",
				"Executado",
				"Reagendado",
				"Faltou"
			];
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			this.findCustomer();
			this.findServices();
			this.findScheduling();

			const currentDate = ref(new Date().toDateString());
			this.intervalId = setInterval(() => {
				const now = new Date().toDateString();
				if (now !== currentDate.value) {
					currentDate.value = now;
					this.findScheduling();
				}
			}, 60000);
		},

		methods: {
			reFindServicesDay () {
				const STATUS = {
					Aguardando: "PENDING",
					"Em andamento": "CONFIRMED",
					Cancelado: "CANCELLED",
					Executado: "COMPLETED",
					Reagendado: "RESCHEDULED",
					Faltou: "NO_SHOW"
				};
				const filters = this.filtersSelected.map(fs => STATUS[fs]);
				this.servicesScheduledOfDay = this.AllServicesScheduledOfDay.filter(ssd => filters.includes(ssd.status));
			},

			getStyle (status) {
				const style = {};

				switch (status) {
					case "PENDING":
						style.color = "blue";
						break;
					case "CONFIRMED":
						style.color = "green";
						break;
					case "CANCELLED":
						style.color = "rgb(255, 81, 0)";
						break;
					case "COMPLETED":
						style.color = "green";
						break;
					case "RESCHEDULED":
						style.color = "rgb(255, 136, 0)";
						break;
					case "NO_SHOW":
						style.color = "red";
						break;
					default:
						style.color = "red";
				}

				return style;
			},

			getStatus (item, action) {
				const { status } = item;
				let disabled = false;
				switch (action) {
					case "start":
						if (status !== "PENDING")
							disabled = true;
						break;
					case "end":
						if (status !== "CONFIRMED")
							disabled = true;

						break;
					case "cancel":
						if (status !== "PENDING")
							disabled = true;

						break;
					case "reschedule":
						if (status !== "PENDING")
							disabled = true;

						break;
					case "missing":
						if (status !== "PENDING")
							disabled = true;

						break;
					default:

				}

				return disabled;
			},

			async actionService (item, action) {
				const { status } = item;
				const error = {};
				const anotherInProgress = await this.findScheduleStart(item);

				switch (action) {
					case "start":
						if (status !== "PENDING") {
							error.message = "O estado do agendamento nao permite aplicar esta acao!";
						}
						if (anotherInProgress)
							error.message = "Existe outro agendamento em andamento!";


						break;
					case "end":
						if (status !== "CONFIRMED")
							error.message = "O estado do agendamento nao permite aplicar esta acao!";

						break;
					case "cancel":
						if (status !== "PENDING")
							error.message = "O estado do agendamento nao permite aplicar esta acao!";

						break;
					case "reschedule":
						if (status !== "PENDING")
							error.message = "O estado do agendamento nao permite aplicar esta acao!";

						break;
					case "missing":
						if (status !== "PENDING")
							error.message = "O estado do agendamento nao permite aplicar esta acao!";

						break;
					default:

				}

				if (error && error.message) {
					await this.$swal.fire({
						title: "Agendamento",
						text: error.message,
						type: "error"
					});
					return;
				}

				const confirmAction = (await this.$swal.fire({
					title: "Tem certeza?",
					text: "Esta ação não poderá ser desfeita!",
					type: "error",
					showCancelButton: true,
					//cancelButtonColor: "#A6A8AB",
					//confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;


				if (!confirmAction) return;

				const { idScheduling } = item;
				const date = new Date();
				const time = new Intl.DateTimeFormat("pt-BR", {
					hour: "2-digit",
					minute: "2-digit",
					hour12: false
				}).format(date);

				try {
					await this.schedulingService.actionScheduling({payload: {idScheduling, action, time}});
					await this.findScheduling();
					const item = this.servicesScheduled.find(item => item.day == this.dataScheduled.getDate());
					await this.modalScheduled(item);
				} catch {
					await this.$swal.fire({
						title: "Agendamento",
						text: "Não foi possível atualizar o estado do agendamento",
						type: "error"
					});
				}
			},

			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 600;
			},

			async findScheduling () {
				this.isLoading = true;
				this.diasSemana = await this.schedulingService.weekDays({ date: this.dateSearch }) || this.getDiasSemana();
				const response = await this.schedulingService.scheduling({ date: this.dateSearch }) || this.getCalendar(this.dateSearch);
				this.servicesScheduled = response.calendar;
				this.optionsTitleMes = response.monthOptions;
				this.isLoading = false;
			},

			fecharModal (modal) {
				this.$refs[modal].hide();
				if (modal === "modalScheduled") {
					this.filtersSelected = [
						"Aguardando",
						"Em andamento",
						"Cancelado",
						"Executado",
						"Reagendado",
						"Faltou"
					];
				}
			},

			limparModal () {
				this.serviceName = "";
				this.serviceValue = "0,00";
				this.customerName = "";
				this.comments = "";
				this.selectedCustomer = null;
				this.selectedService = null;
				this.eventual = false;
				this.selectedIdScheduling = null;
				this.idCustomer = null;
				this.idService = null;
				this.startTime = this.getNowHour();
				this.serviceDuration = "01:00";
				this.invalidForm = true;
				this.saving = false;

				this.reminderTask = [];
				this.taskReminderCustomerValue = "10";
				this.taskReminderCustomerDelay = "1";
				this.invalidTaskReminderCustomer = true;
				this.optionsReminderTask.forEach(ort => {
					ort.checked = false;
				});
			},

			async save () {
				const [hours, minutes] = this.startTime.split(":").map(Number);
				const [sumHours, sumMinutes] = this.serviceDuration.split(":").map(Number);

				const scheduleEndTime_ = new Date(0, 0, 0, hours, minutes);
				scheduleEndTime_.setHours(scheduleEndTime_.getHours() + sumHours);
				scheduleEndTime_.setMinutes(scheduleEndTime_.getMinutes() + sumMinutes);

				const hoursEnd = scheduleEndTime_.getHours().toString().padStart(2, "0");
				const minutesEnd = scheduleEndTime_.getMinutes().toString().padStart(2, "0");

				const scheduleEndTime = `${hoursEnd}:${minutesEnd}`;
				const payload = {
					idScheduling: this.selectedIdScheduling,
					idCustomer: !this.eventual ? this.selectedCustomer : null,
					idService: !this.eventual ? this.selectedService : null,
					schedulingDetails: this.eventual ? {
						service: this.serviceName,
						customer: this.customerName
					} : null,
					date: this.dataScheduled,
					scheduleStartTime: this.startTime,
					scheduleEndTime,
					amount: stringToNumberToFixed(this.serviceValue),
					comments: this.comments,
					taskReminders: this.reminderTask
				};

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				const availability = this.checkScheduleAvailability(payload);
				if (!availability) {
					return 	await this.$swal.fire({
						title: "Agendamento",
						text: "Por favor, verifique a disponibilidade, já existe um agendamento para esse horário.",
						type: "error"
					});
				}

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						if (payload.idScheduling)
							await this.schedulingService.updateScheduling({payload});
						else
							await this.schedulingService.createScheduling({payload});

						this.fecharModal("modalScheduledEdit");
						this.limparModal();
						await this.findScheduling();

						const item = this.servicesScheduled.find(item => item.day == this.dataScheduled.getDate());
						await this.modalScheduled(item);

						return {
							title: "Sucesso!",
							body: "Agendamento salvo com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar o agendamento!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			changeToggle (status, field) {
				this[field] = !status;

				if (field === "eventual") {
					this.serviceName = "";
					this.customerName = "";
					this.selectedCustomer = null;
					this.selectedService = null;
					this.idCustomer = null;
					this.idService = null;
				}
			},

			async findMonth (value) {
				this.isLoading = true;
				if (value) {
					const month = this.dateSearch.getMonth();

					switch (value) {
						case -1:
							this.dateSearch.setMonth(month - 1);
							break;
						case 1:
							this.dateSearch.setMonth(month + 1);
							break;
						default:
							break;
					}
				}

				const response = await this.schedulingService.scheduling({ date: this.dateSearch }) || this.getCalendar(this.dateSearch);
				this.servicesScheduled = response.calendar;
				this.optionsTitleMes = response.monthOptions;
				this.isLoading = false;
			},

			modalScheduled (item) {
				this.dataScheduled = new Date(this.dateSearch);
				this.dataScheduled.setDate(item.day);
				const strDataScheduled = dayjs(new Date(this.dataScheduled)).locale("pt-br").format("DD-MM-YYYY");
				this.titleModal = `Agendamentos ${strDataScheduled}`;
				this.AllServicesScheduledOfDay = item.scheduled.reduce((acc, sd) => {
					acc.push(sd);

					return acc;
				}, []);
				this.servicesScheduledOfDay = this.AllServicesScheduledOfDay.map(ele => ele);
				this.reFindServicesDay();
				this.$refs.modalScheduled.show();
			},

			schedulingEdit (item) {
				if (!possuiPermissao("SCHEDULING_U"))
					return;

				if (item && item.status !== "PENDING")
					return;

				this.limparModal();
				this.titleModalEdit = `${this.titleModal}`;
				if (item) {
					const duration = diffTime(item.scheduleStartTime, item.scheduleEndTime);

					this.serviceName = item.service;
					this.serviceValue = numberFormatted(item.amount);
					this.customerName = item.customer;
					this.selectedCustomer = item.idCustomer;
					this.selectedService = item.idService;
					this.eventual = Boolean(!this.selectedCustomer);
					this.selectedIdScheduling = item.idScheduling;
					this.startTime = item.scheduleStartTime;
					this.serviceDuration = duration;
					this.comments = item.comments;
					this.reminderTask = item.taskReminder.map(ele => ele);
					this.reminderTask.sort((a, b) => a.valueMinutes - b.valueMinutes);

					const reminderTaskSelected = this.reminderTask.map(rt => rt.valueMinutes);
					this.optionsReminderTask.forEach(ort => {
						if (reminderTaskSelected.includes(ort.valueMinutes)) {
							ort.checked = true;
						}
					});
				}

				const now = new Date();
				const dateSelected = new Date(this.dataScheduled);
				const daySelected = dateSelected.getDate();
				const monthSelected = dateSelected.getMonth();
				const yearSelected = dateSelected.getFullYear();

				this.hourRange = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].reduce((acc, h) => {
					const validateDate = new Date(yearSelected, monthSelected, daySelected, h, 59, 59);

					if (now <= validateDate)
						acc.push(h);

					return acc;
				}, []);

				if (!this.hourRange.length) {
					if (!item) {
						this.startTime = null;
						this.serviceDuration = null;
					}
					this.disabledHour = true;
				} else {
					this.disabledHour = false;
				}

				this.$refs.modalScheduledEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				this.invalidTaskReminderCustomer = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			async updateValue (key) {
				const value = this[key];
				this[key] = await validateNumber(value);
			},

			handleFocus (key) {
				if (isNullValue(this[key]))
					this[key] = "";
				else
					this[key] = this[key].toString().replace(".", "");
			},

			handleBlur (key) {
				if (!this[key]) {
					this[key] = "0,00";
				} else {
					this[key] = numberFormatted(stringToNumber(this[key]));
				}
			},

			async findCustomer () {
				const result = await this.customerService.listCustomer({offset: 0, limit: null}) || {};

				this.optionsCustomer = result.rows?.reduce((acc, item) => {
					acc.push({ text: item.description, value: item.idCustomer });

					return acc;
				}, []);
			},

			async findServices () {
				this.services = await this.productService.listProduct({offset: 0, limit: null}) || {};
				this.optionsService = this.services.rows?.reduce((acc, item) => {
					if (item["productClass.service"])
						acc.push({ text: item.description, value: item.idProduct });

					return acc;
				}, []);
			},

			setValueService () {
				this.serviceValue = numberFormatted((this.services.rows.find(s => s.idProduct == this.selectedService))?.sale3 || "0");
			},

			findScheduleStart () {
				const anotherInProgress = Boolean(this.servicesScheduledOfDay.find(sd => sd.status === "CONFIRMED"));
				return anotherInProgress;
			},

			checkScheduleAvailability (newSchedule) {
				let availability = this.servicesScheduledOfDay;
				if (newSchedule.idScheduling) {
					const scheduled = availability.find(s => s.idScheduling === newSchedule.idScheduling);
					if (newSchedule.scheduleStartTime === scheduled.scheduleStartTime && newSchedule.scheduleEndTime === scheduled.scheduleEndTime)
						return true;

					availability = this.servicesScheduledOfDay.filter(s => s.idScheduling !== newSchedule.idScheduling && (s.status === "PENDING" || s.status === "CONFIRMED"));
				} else {
					availability = this.servicesScheduledOfDay.filter(s => s.status === "PENDING" || s.status === "CONFIRMED");
				}

				const [newHoursStart, newMinuteStart] = newSchedule.scheduleStartTime.split(":").map(Number);
				const [newHoursEnd, newMinutesEnd] = newSchedule.scheduleEndTime.split(":").map(Number);
				const newScheduleStart = newHoursStart * 60 + newMinuteStart;
				const newScheduleEnd = newHoursEnd * 60 + newMinutesEnd;
				let notAvailability = false;

				for (let idx = 0; idx < availability.length; idx++) {
					const [sdHoursStart, sdMinuteStart] = availability[idx].scheduleStartTime.split(":").map(Number);
					const [sdHoursEnd, sdMinutesEnd] = availability[idx].scheduleEndTime.split(":").map(Number);
					const sdScheduleStart = sdHoursStart * 60 + sdMinuteStart;
					const sdScheduleEnd = sdHoursEnd * 60 + sdMinutesEnd;

					if (newScheduleStart < sdScheduleEnd && sdScheduleStart < newScheduleEnd) {
						notAvailability = true;
						break;
					}
				}

				return !notAvailability;

			},

			isToday () {
				const today = new Date();
				return (
					today.getDate() === this.dataScheduled.getDate() &&
					today.getMonth() === this.dataScheduled.getMonth() &&
					today.getFullYear() === this.dataScheduled.getFullYear()
				);
			},

			getNowHour () {
				if (this.dataScheduled && this.isToday()) {
					const hour = new Date().getHours();

					return `${hour.toString().padStart(2, "0")}:00"`;
				}

				return "08:00";
			},

			toggleAllSelected (checked) {
				if (checked) {
					this.filtersSelected = [...this.optionsFilter];
				} else {
					this.filtersSelected = [];
				}
			},

			addTaskReminder () {
				this.$refs.modalAddTaskReminder.show();
			},

			delTaskReminder (index) {
				const reminderTaskDeleted = this.optionsReminderTask.find(ort => ort.valueMinutes == this.reminderTask[index].valueMinutes);
				if (reminderTaskDeleted && reminderTaskDeleted.checked) {
					reminderTaskDeleted.checked = false;
				}

				this.reminderTask.splice(index, 1);
			},

			selectOptionTaskReminder (index) {
				if (index < this.optionsReminderTask.length - 1) {
					if (!this.isHaveReminderTask(this.optionsReminderTask[index].valueMinutes)) {
						this.optionsReminderTask[index].checked = true;
						this.reminderTask.push({
							description: this.optionsReminderTask[index].description,
							valueMinutes: this.optionsReminderTask[index].valueMinutes
						});
						this.reminderTask.sort((a, b) => a.valueMinutes - b.valueMinutes);
					}
					this.$refs.modalAddTaskReminder.hide();
				} else {
					this.$refs.modalReminderTaskCustomer.show();
				}
			},

			addTaskReminderCustomer () {
				const delay = this.taskReminderCustomerValue * this.taskReminderCustomerDelay;
				const optionSelected = this.optionsCustomerDelay.find(ocd => ocd.value == this.taskReminderCustomerDelay);
				const description = `${this.taskReminderCustomerValue} ${optionSelected.text} antes`;

				if (!this.isHaveReminderTask(delay)) {
					this.reminderTask.push({
						description,
						valueMinutes: delay
					});
				}

				this.reminderTask.sort((a, b) => a.valueMinutes - b.valueMinutes);
				this.$refs.modalReminderTaskCustomer.hide();
				this.$refs.modalAddTaskReminder.hide();
			},

			isHaveReminderTask (delay) {
				const reminderTaskSelected = this.reminderTask.map(rt => rt.valueMinutes);
				if (reminderTaskSelected.includes(delay)) {
					return true;
				}

				return false;
			}

		}
	};
</script>

<style scoped>
.center {
	justify-content: center !important;
	width: 24px;
}

.center-vh {
	display: flex;
	align-items: center;
}

.color-yellow {
	color: rgb(255, 81, 0);
}

.color-red {
	color: red;
}

.color-green {
	color: rgb(39, 41, 39);
}

.vue-timepicker input {
  text-align: center !important;
}

.menu {
	/* position: absolute; */
    /* right: 16px; */
	margin-left: 5px;
    /* top: 16px; */
	margin-bottom: 16px;
}

.btn-menu {
    border-radius: 50%;
	color: var(--gris40);
	cursor: pointer;
}

.calendar {
  display: grid;
  padding: 0px;
  width: 100%;
  grid-template-columns: repeat(7, 1fr);
  background: azure;
}

.title-month {
  background: azure;
  display: flex;
  width: 100%;
  margin-top: 14px;
}

.button-arrow {
  display: flex;
  width: 5%;
  background: var(--color-button-grey);
  border-style: outset;
  border-color: var(--color-button-grey-hover);
  border-width: 1px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}

.button-arrow:hover {
  background: var(--color-button-grey-hover);
}

.button-arrow:focus {
  background: var(--color-green-light);
}

.modal-edicao-input {
	font-family: 'Roboto Condensed Regular';
	font-size: 1rem;
}

.number-class {
	text-align: right;
}

.label-parcela {
  margin-bottom: 0px;
  color: #696969 !important;
  width: 10rem;
}

.text-parcela {
  font-family: 'Roboto Condensed Regular';
  font-size: 16px;
}

.btn-salvar-top {
  width: 11.25rem;
  white-space: noWrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px;
}

.table-margin-top {
  margin-top: calc(50px + 2rem);
}

.responsive-filter-modal {
	display: flex;
	justify-content: space-evenly;
}
.filter-rows {
	width: 50%;
	padding: 1.25rem 0 1.25rem 1.25rem;
	font-size: 1.15rem;
}
.filter-rows-next {
	padding-left: 0.8rem;
	padding-right: 1.25rem;
}

.icon-payment {
	display: flex;
	justify-content: center;
	background-color: green;
	color: white;
	padding: 2px;
}

.icon-delete {
	display: flex;
	justify-content: center;
	background-color: red;
	color: white;
	padding: 2px;
}


.label-parcela {
	margin-bottom: 0px;
	color: #696969 !important;
	width: 10rem;
}

.text-parcela {
	font-family: 'Roboto Condensed Regular';
	font-size: 1rem;
}

.table-parcelas {
	padding-left: 2rem;
	margin-bottom: 12px;
	max-height: 25vh;
	overflow-y: scroll;
	overflow-x: hidden;
	border: solid 1px #e2e2e2;
	background-color: #f7f5f5;
	border-top: none;
}

.justify-items {
	align-items: center;
}

.label-table {
	background-color: #f0efef;
	font-family: 'Roboto Condensed Regular';
	color: #696969 !important;
	border: solid 1px #e2e2e2;
	border-bottom: none;
	height: 3rem;
}

.modal-edicao-input {
	font-family: 'Roboto Condensed Regular';
	font-size: 1rem;
}

.dashboard {
	padding-left: 8px;
	padding-right: 8px;
}

.select-dashboard {
	min-width: 130px;
	max-width: 200px;
	width: 20%;
	font-family: "Roboto Condensed Regular";
	font-size: 0.875rem;
}

.section-select-dashboard {
	width: 100%;
	display: flex;
	justify-content: right;
}

@media (max-width: 1576px) {
  .button-arrow {
    width: 6%
  }
}

@media (max-width: 1024px) {
  .button-arrow {
    width: 9%
  }
}

@media (max-width: 768px) {
	.responsive-filter-modal {
		display: block;
	}
	.filter-rows {
		padding-left: 1.8rem;
		padding-right: 0;
		width: 100%;
	}
	.filter-rows-next {
		padding-top: 0;
		margin-top: -1rem;
	}
}

@media (max-width: 600px) {
  .button-arrow {
    width: 11%
  }
}

.tabla-contenedor {
  height: 400px;
  overflow: hidden;
  border: none;
}

.tabla {
  height: 100%;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

thead {
  background-color: #eee;
}

.scroll {
	overflow-y: scroll;
	overflow-x: hidden;
}

tbody {
  display: block;
  height: 100%;
  background-color: #fff;
  min-height: 57vh;
  max-height: 65vh;
}

thead tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

th, td {
  padding: 8px;
  border: none;
}
</style>